import { render, staticRenderFns } from "./TopNavigationList.vue?vue&type=template&id=10470770&"
import script from "./TopNavigationList.vue?vue&type=script&lang=js&"
export * from "./TopNavigationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports